




















import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "@/components/menu/Header.vue";
import Footer from "@/components/Footer.vue";
import bus from "./bus";
import { mapGetters } from "vuex";

@Component({
	components: {
		Header,
		Footer
	},
	beforeMount() {
		this.$forceUpdate();
	},
	computed:{
		...mapGetters(["getUser"]),
	}
})
export default class App extends Vue {
	id: string;

	data() {
		return {
			id: null
		};
	}

	created() {
		bus.$on("userchange", id => {
			console.log("se ha cambiado de empresa papa");
			this.id = id;
		});
	}
}
